import { EUserRolesUI } from 'data/types/user.types';
import { useProfile } from 'hooks/useProfile';

export default function useCanCreateContract() {
  const profile = useProfile();

  return [EUserRolesUI.LANDLORD, EUserRolesUI.PROPERTY_MANAGER].includes(profile?.type) && profile?.canCreateContract;
}
